import React from 'react';
import './ALaCarte.scss';

function ALaCarte() {
    return (
        <div className="aLaCarte">
            <div className="aLaCarte__bg"></div>
            <div className="aLaCarte__menu">
                        <div className="aLaCarte__info">
                            taco chicken
                        </div>
                        <div className="aLaCarte__price">$2.00</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            taco de asada
                        </div>
                        <div className="aLaCarte__price">$1.70</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            taco de lengua
                        </div>
                        <div className="aLaCarte__price">$2.00</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            enchiladas
                        </div>
                        <div className="aLaCarte__price">$2.00</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            taquitos
                        </div>
                        <div className="aLaCarte__price">$2.25</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            taco de cabeza
                        </div>
                        <div className="aLaCarte__price">$2.00</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            taco beef
                        </div>
                        <div className="aLaCarte__price">$2.00</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            Tamal
                        </div>
                        <div className="aLaCarte__price">$1.86</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            cheese Quesadilla
                        </div>
                        <div className="aLaCarte__price">$3.95</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            taco adovada
                        </div>
                        <div className="aLaCarte__price">$1.70</div>
                </div>
                <div className="aLaCarte__menu">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="aLaCarte__info">
                            Meat quesadilla
                        </div>
                        <div className="aLaCarte__price">$5.80</div>
                </div>
        </div>
    )
}

export default ALaCarte
